export var ACTION;
(function (ACTION) {
    ACTION["PORTFOLIO"] = "PORTFOLIO";
    ACTION["SEARCH_PORTFOLIO"] = "SEARCH_PORTFOLIO";
    ACTION["CLEAR_SEARCH_PORTFOLIO"] = "CLEAR_SEARCH_PORTFOLIO";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["TOGGLE_ITEM"] = "TOGGLE_ITEM";
    ACTION["EDIT_ITEM"] = "EDIT_ITEM";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["CLOSE_POPUP"] = "CLOSE_POPUP";
})(ACTION || (ACTION = {}));
